<p-fieldset legend="Gradebook for {{courseCode}}">
    @if(noDataFound()===true){
       <p-message severity="info">No grades yet.</p-message> 
    }@else{
        <p class="my-4">
        <p-iftalabel>
            <input pInputText [formControl]="searchQuery" autocomplete="off" fluid/> 
            <label>Search...</label>
        </p-iftalabel>   
        <small id="searchQuery-help">Use learner first/last name or email to search (min. 5 characters)</small>
    </p>
        <p class="m-0">
            <p-table selectionMode="single" 
                    [value]="gradeBook" 
                    size="small" 
                    [loading]="loading()" 
                    stripedRows 
                    showGridlines 
                    [paginator]="true"  
                    [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10,50,100,200,500]" 
                    [(selection)]="selectedLearnerWithGrade" 
                    dataKey="id"
                    [lazy]="true" 
                    [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="firstName">
                                    Learner First Name <p-sortIcon field="firstName"/>
                                </th>
                                <th pSortableColumn="lastName">
                                    Learner Last Name <p-sortIcon field="lastName"/>
                                </th>
                                <th pSortableColumn="email">
                                    Email <p-sortIcon field="email"/>
                                </th>
                                <th pSortableColumn="scoreGiven">Score <p-sortIcon field="scoreGiven"/></th>
                                <th  pSortableColumn="scoreMaximum">Maximum Score<p-sortIcon field="scoreMaximum"/></th>
                                <th>Activity Progress</th>
                                <th>Grading Progress</th>
                                <th>Graded On</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-learnerWithGrade>
                            <tr [pSelectableRow]="learnerWithGrade">
                                <td>{{ learnerWithGrade.firstName }}</td>
                                <td>{{ learnerWithGrade.lastName }}</td>
                                <td>{{ learnerWithGrade.email }}</td>
                                <td>{{ learnerWithGrade.scoreGiven }}</td>
                                <td>{{ learnerWithGrade.scoreMaximum }}</td>
                                <td>{{ learnerWithGrade.activityProgress }}</td>
                                <td>{{ learnerWithGrade.gradingProgress }}</td>
                                <td>{{ learnerWithGrade.gradedOn | date }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
    }
    
</p-fieldset>

        